import { alert } from "@components/common/Alert";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarEmpty } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { Controller } from "react-hook-form";

export default function FavoriteToggle({ control }) {
  return (
    <Controller
      name="isFavourite"
      control={control}
      render={({ field }) => (
        <label className="flex flex-row items-center gap-sm cursor-pointer">
          <input
            {...field}
            type="checkbox"
            className="sr-only"
            checked={field.value}
            onChange={(evt) => {
              field.onChange(evt.target.checked);
              alert(
                "success",
                `You've ${
                  evt.target.checked ? "marked" : "unmarked"
                } this template as a favorite. ${
                  evt.target.checked
                    ? "It will now be displayed at the top of your templates list."
                    : "It will no longer be displayed at the top of your templates list."
                }`,
              );
            }}
          />
          <Tooltip
            title={`Click to ${
              field.value ? "unmark" : "mark"
            } this template as a favorite. ${
              field.value
                ? ""
                : "If favorited, it will be displayed at the top of your templates list."
            }`}
            arrow
            placement="right"
          >
            <div>
              <FontAwesomeIcon
                icon={field.value ? faStar : faStarEmpty}
                size="lg"
                className="text-yellow-500 hover:text-yellow-600 transition"
              />
            </div>
          </Tooltip>
          <span className="text-sm text-primary font-medium">
            {field.value ? "Unmark" : "Mark"} Template as Favorite
          </span>
        </label>
      )}
    />
  );
}
